import { render, staticRenderFns } from "./flowmodal.vue.html?vue&type=template&id=535c3812"
import script from "./flowmodal.controller?vue&type=script&lang=js&external"
export * from "./flowmodal.controller?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports